import React, { useEffect, useState } from "react";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import Constants from "../../data/Constants";
import Utils from "../../utils/index";
import { isMobile } from "react-device-detect";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import moment from "moment";
import { getUserList } from "../../services/user.service";

function Students(props) {
  const navigate = useNavigate();
  const [data, setData] = useState(false);
  const { setProgress, setToast, isRefreshed } = useOutletContext();

  useEffect(() => {
    setProgress(true);

    async function api() {
      try {
        const data = await getUserList({ type: "Student" }); // no students
        if (data) {
          setData(data);
          setProgress(false);
        } else {
          // error

          setProgress(false);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error

        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }
    api();
  }, [isRefreshed]);

  function CustomRow(props) {
    const { row, index, skipValue } = props;

    return (
      <>
        <TableRow key={row._id}>
          <TableCell>{index + 1 + skipValue}</TableCell>
          <TableCell>
            {row.firstname ? row.firstname + " " + row.lastname : "Not Set"}
          </TableCell>
          <TableCell>{row.grade}</TableCell>
          <TableCell>{moment(row.dob).format("DD-MM-YYYY")}</TableCell>
          <TableCell>
            {row.parent && row.parent.firstname
              ? row.parent.firstname + " " + row.parent.lastname
              : "Not Set"}
          </TableCell>
          <TableCell>
            {moment(row.createdAt).format("dddd, MMMM Do YYYY, h:mm a")}
          </TableCell>
          <TableCell>
            {/* <Button
              size="small"
              onClick={(e) => {
                navigate("/dashboard/mentor/edit/" + row._id, {
                  state: { mentor: row },
                });
              }}
            >
              Edit
            </Button> */}

            <Button
              size="small"
              variant="contained"
              onClick={() =>
                navigate("/dashboard/students/" + row._id, {
                  state: {
                    student: row,
                    boughtCourses: [],
                  },
                })
              }
            >
              View
            </Button>
          </TableCell>
        </TableRow>
      </>
    );
  }

  return (
    <div>
      <Box style={{ width: "100%" }}>
        <TableContainer>
          <div className="flex justify-end gap-5">
            {/* <Button
              variant="outlined"
              className="my-8"
              onClick={(e) => {
                navigate("/dashboard/mentor/edit");
              }}
            >
              Create Mentor
            </Button> */}
          </div>
          <Table size="small">
            <TableHead className="">
              <TableRow className=""></TableRow>
              <TableRow>
                <TableCell style={{ fontWeight: "bold" }}>ID</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Fullname</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Grade</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>DOB</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Parent</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Created At</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data
                ? data.map((row, index) => {
                    return (
                      <CustomRow
                        row={row}
                        key={index}
                        index={index}
                        skipValue={0}
                      />
                    );
                  })
                : null}
            </TableBody>
          </Table>
          {/* <div style={{ marginTop: '20px', textAlign: 'center' }} hidden={survey.length != 0}>
                No data with given filters
            </div> */}
        </TableContainer>
      </Box>
    </div>
  );
}

export default Students;
